module.exports = __webpack_public_path__ + "img/album18_26.778b6532.jpg";